import React, { useEffect, useState } from 'react'

import { SelectForm } from 'components'
import SimpleCollapse from 'components/Collapse/SimpleCollapse'

import { Acionador, Diario, Mensal, Semanal } from './components'

interface IPeriodicidade {
  setValue: any
  control: any
  errors: any
  clearErrors: any
  onSubmitPeriodicidade: (data) => void
  setHasErrorJob: (value) => void
  watch: any
  tipoRecorrencia: string
  jobRecorrenciasList?: any[]
  jobNuDiasRecorrencia?: string
  jobDiasSemanaRecorrencia?: string
}

const Periodicidade: React.FC<IPeriodicidade> = ({
  control,
  errors,
  clearErrors,
  watch,
  onSubmitPeriodicidade,
  setValue,
  tipoRecorrencia,
  setHasErrorJob,
  jobRecorrenciasList,
  jobNuDiasRecorrencia,
  jobDiasSemanaRecorrencia
}) => {
  const periodicidade = watch('tipo')
  const mensal = watch('mensal')
  const semanal = watch('semanal')
  const diario = watch('horarios')
  const acionador = watch('acionador')
  const diasSemana = watch('diasSemana')

  const listOptions = [
    {
      label: 'Diário',
      value: 'Diario'
    },
    {
      label: 'Semanal',
      value: 'Semanal'
    },
    {
      label: 'Mensal',
      value: 'Mensal'
    },
    {
      label: 'Acionador',
      value: 'Acionador'
    }
  ]

  const periodicidades = {
    Acionador: (
      <Acionador
        acionador={acionador}
        setValue={setValue}
        listOptions={listOptions}
        control={control}
        periodicidade={periodicidade}
        jobRecorrenciasList={jobRecorrenciasList}
        onSubmitPeriodicidade={onSubmitPeriodicidade}
      />
    ),
    Diario: (
      <Diario
        diario={diario}
        setValue={setValue}
        listOptions={listOptions}
        control={control}
        periodicidade={periodicidade}
        jobRecorrenciasList={jobRecorrenciasList}
        onSubmitPeriodicidade={onSubmitPeriodicidade}
        setHasErrorJob={setHasErrorJob}
      />
    ),
    Mensal: (
      <Mensal
        mensal={mensal}
        setValue={setValue}
        listOptions={listOptions}
        errors={errors}
        clearErrors={clearErrors}
        control={control}
        periodicidade={periodicidade}
        jobRecorrenciasList={jobRecorrenciasList}
        setHasErrorJob={setHasErrorJob}
        onSubmitPeriodicidade={onSubmitPeriodicidade}
        jobNuDiasRecorrencia={jobNuDiasRecorrencia}
      />
    ),
    Semanal: (
      <Semanal
        diasSemana={diasSemana}
        semanal={semanal}
        setValue={setValue}
        listOptions={listOptions}
        control={control}
        periodicidade={periodicidade}
        setHasErrorJob={setHasErrorJob}
        jobRecorrenciasList={jobRecorrenciasList}
        jobDiasSemanaRecorrencia={jobDiasSemanaRecorrencia}
        onSubmitPeriodicidade={onSubmitPeriodicidade}
      />
    )
  }

  useEffect(() => {
    setValue('tipo', tipoRecorrencia)
  }, [])

  return (
    <SimpleCollapse title="Periodicidade">
      {!periodicidade && (
        <SelectForm
          control={control}
          listOptions={listOptions}
          label="Tipo"
          formValue="tipo"
          width="130px"
        />
      )}
      {periodicidades[periodicidade]}
    </SimpleCollapse>
  )
}

export default Periodicidade
